import { compareValues } from "@ls/js-utils";
import React from "react";
import Combobox from "@ls/react-combobox-grid";
import { useDispatch, useSelector } from "react-redux";
import { setGroupType } from "state/selections/actions";
import { GroupTypeEntity } from "state/selections/GroupType";
import SelectionState from "state/selections/SelectionState";
import { selectGroupTypeValue } from "state/selections/selector";

const options = Object.values(GroupTypeEntity)
  .map(({ label, value }) => ({ label, value }))
  .sort(compareValues("label"));

const GroupTypeSelector = (props) => {
  const dispatch = useDispatch();
  const onChange = React.useCallback(
    (value) => {
      dispatch(setGroupType(value));
    },
    [dispatch]
  );

  const groupTypeValue = useSelector(
    selectGroupTypeValue(SelectionState.UNCOMMITTED)
  );
  return (
    <Combobox
      placeholder="Custom Account Groups..."
      options={options}
      onChange={onChange}
      value={groupTypeValue}
      label="Group Type: "
      variation={1}
      gridHeight={200}
    />
  );
};
export default GroupTypeSelector;
